import { useEffect, useState } from 'react'

const none = { display: 'none' }
const empty = {}

const ScrollbarWidth: React.FC<Nothing> = () => {
  const [show, setShow] = useState(true)
  const [ref, setRef] = useState<HTMLDivElement | null>(null)
  useEffect(() => {
    if (!ref) return
    const inner = ref
    const outer = ref.parentElement
    if (!outer) return
    const scrollbar = outer?.offsetWidth - inner.offsetWidth
    const root = document.documentElement
    root.style.setProperty('--scrollbar-width', `${scrollbar}px`)
    setShow(false)
    return () => {
      if (!ref) return
      root.style.removeProperty('--scrollbar-width')
    }
  }, [ref])
  return (
    <div
      style={{
        ...(show ? empty : none),
        height: '0px',
        visibility: 'hidden',
        overflow: 'scroll'
      }}
    >
      <div ref={setRef}></div>
    </div>
  )
}

export default ScrollbarWidth
